import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { CustomerDashboard } from '../customer-dashboard/customer-dashboard.component';
import { getDefaultLanding } from '../../actions/utils';

// Landing for /dashboard:
//  - Drivers (role 2) never see the customer Shipping Dashboard — bounce them to
//    their configured default landing (Schedules by default). This also catches
//    direct nav to /dashboard (the sidebar/header already filter the Dashboard
//    tab out for drivers via restrictRoles: [2]).
//  - Admin & Super Admin: the initial-load redirect is handled by Gateway/login
//    on app mount; subsequent in-app clicks of the "Dashboard" header tab
//    intentionally let admins view the Shipping Dashboard, so we do NOT redirect
//    them here.
export const Landing = () => {
  const role = useSelector(state => get(state, 'user.role'));
  if (role === 2) {
    const target = getDefaultLanding(2);
    // Avoid redirecting to /dashboard itself (would loop on this component).
    if (target && target !== '/dashboard') return <Redirect to={target} />;
  }
  return <CustomerDashboard />;
};
